// Прилипающее боковое меню на детальной странице
itsoftApp.createModule("fixedDetailMenu", function() {
    if ($(".sd-menu__scroll").length) {
        var box = $(".sd-menu__scroll"),
        boxContainer = $(".sd-menu"),
        boxHeight = parseInt(box.height()),
        boxContainerPos = parseInt(boxContainer.offset().top + boxContainer.height() - 100),
        top = box.offset().top;
        function fixedDM() {

                    if ($(window).width() > 1180) {
                        var windowpos = $(window).scrollTop() + 100,
                            bottom = $(window).scrollTop() + boxHeight;
                        if(windowpos < top) {
                            box.css({"position":"static",
                                    "bottom":"0px",
                                    "right":"0px",
                                    "top":"0px",});
                        }
                        else if (windowpos > top && bottom < boxContainerPos) {
                            box.css({"position":"fixed",
                                    "bottom":"initial",
                                    "right":"initial",
                                    "top":"100px",});
                        }
                        else {
                            box.css({"position":"absolute",
                                    "bottom":"0px",
                                    "right":"0px",
                                    "top":"initial",});
                        }
                    }
                    else if ($(window).width() <= 1180) {
                        box.css({"position":"static",
                                "bottom":"0px",
                                "right":"0px",
                                "top":"0px",});
                    }

        }
        $(window).scroll(function() {
            fixedDM();
        });
        $(window).resize(function() {
            fixedDM();
        });
        fixedDM();
    }
});
